import { css } from 'styled-components'

// Override the ext-ui Checkbox's `display: inline-block` to `flex` so the
// native <input> doesn't baseline-align below the cell's vertical center.
export const checkboxCellCss = css`
  display: flex;
  align-items: center;
  height: 100%;

  & > .Checkbox {
    display: flex;
  }
`

export const mccGroupsBoxCss = css`
  overflow: hidden;
`
